export default "__VITE_ASSET__Dc3COY1q__"